import React from 'react';
import PropTypes from 'prop-types';

export default function LoaderProductos({ vista }) {
  if (vista === 'list') {
    return (
      <div role="status" className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden animate-pulse">
        <div className="flex gap-4 p-4">
          <div className="w-24 h-24 rounded-xl bg-gray-100 shrink-0" />
          <div className="flex-1 space-y-2.5 py-1">
            <div className="h-4 bg-gray-100 rounded-lg w-2/3" />
            <div className="h-3 bg-gray-100 rounded-lg w-1/3" />
            <div className="h-3 bg-gray-100 rounded-lg w-full" />
            <div className="h-3 bg-gray-100 rounded-lg w-5/6" />
          </div>
        </div>
        <span className="sr-only">Cargando producto...</span>
      </div>
    );
  }

  return (
    <div role="status" className="group flex flex-col w-full rounded-2xl overflow-hidden border border-gray-100 shadow-sm animate-pulse bg-white">
      {/* Image area */}
      <div className="h-44 md:h-60 bg-gray-100 relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <svg className="w-12 h-12 text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
          </svg>
        </div>
      </div>
      {/* Title bar */}
      <div className="p-3 bg-gray-200">
        <div className="h-4 bg-gray-300 rounded-lg w-3/4 mx-auto" />
      </div>
      <span className="sr-only">Cargando producto...</span>
    </div>
  );
}

LoaderProductos.propTypes = {
  vista: PropTypes.string.isRequired,
};
